import { css } from 'aphrodite';
import { SharedCarousel } from 'components';
import { Achievement } from 'components/Achievement/Achievement';
import { useScrollToTopOnMount } from 'hooks';
import useAchievements from 'hooks/useAchievements';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { isExhibitorUser } from 'redux/reducers/user';
import { RootState } from 'redux/store';
import { checkIfTrue } from 'util/helpers';
import { style } from './style';
interface Props {}

export const Achievements: FC<Props> = () => {
  useScrollToTopOnMount();
  const styles = style();
  const userAchievements = useAchievements(true);
  const achievementsConfig = useSelector((state: RootState) => state.widget.cms.text.achievements);
  const isExhibitor = useSelector(isExhibitorUser);

  let achievements = [];

  for (const categoryName in achievementsConfig.categories) {
    const category = achievementsConfig.categories[categoryName];
    const id = category.id;
    const catCount = userAchievements.categories[id]?.total || 0;
    const catTotal = parseInt(category.total, 10);
    const progress = Math.round((catCount / catTotal) * 100);

    if (!checkIfTrue(category.display_to_exhibitors) && isExhibitor) {
      continue;
    }

    achievements.push(
      <Achievement
        name={category.title}
        icon={category.icon}
        progress={progress}
        description={category.description}
        key={category.id}
      />
    );
  }

  return (
    <main className={css(styles.main)}>
      <section className={css(styles.section)}>
        <SharedCarousel />
        <div className={css(styles.content)}>
          <h1 className={css(styles.title)}>{achievementsConfig.headline}</h1>

          <p
            className={css(styles.description)}
            dangerouslySetInnerHTML={{ __html: achievementsConfig.description }}></p>
          <div className={css(styles.achievements)}>{achievements}</div>
        </div>
      </section>
    </main>
  );
};
